import React from "react";
import { Layout } from "react-admin";
import { MenuItemLink, getResources } from "react-admin";
import { useSelector } from "react-redux";
import ListIcon from "@material-ui/icons/List";
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import SearchIcon from "@material-ui/icons/Search";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import Group from "@material-ui/icons/Group";

const Menu = ({ onMenuClick }) => {
    const resources = useSelector(getResources);
    return (
        <div>
            {resources.map((resource) => (
                <MenuItemLink
                    key={resource.name}
                    to={`/${resource.name}`}
                    primaryText={
                        resource?.options.label || resource.name
                    }
                    leftIcon={resource.name === "profiles" ? <Group/> : <LocalHospitalIcon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={true}
                />
            ))}
            <MenuItemLink
                to="/availableVets"
                primaryText="Available Vets"
                leftIcon={<ListIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={true}
            />
            <MenuItemLink
                to="/addVetSchedule"
                primaryText="Add Vet Schedule"
                leftIcon={<AddCircleOutlineIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={true}
            />
            <MenuItemLink
                to="/removeVetAvailability"
                primaryText="Remove Vet Availability"
                leftIcon={<RemoveCircleOutlineIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={true}
            />
            <MenuItemLink
                to="/searchPetParent"
                primaryText="Search Pet Parent"
                leftIcon={<SearchIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={true}
            />
        </div>
    );
};


const AdminLayout = (props) => <Layout {...props} menu={Menu} />;

export default AdminLayout;
